module.exports = __webpack_public_path__ + "img/gift1.42b009ed.png";